import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { simulatorTabsData } from "../../../data/SidebarData";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const SimlulatorCivilIndex = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={simulatorTabsData} />
      <StaticPageForm title="Simulator" category={"civil"} promo subscription />
    </div>
  );
};

export default SimlulatorCivilIndex;
